<template>
    <div>
        <sav-responsive-access-template logo="@/companies/marketmaker/assets/logo.png">
            <div class="w-full pt-4 bg-black">
                <img src="https://disticloudfiles.net/img/savinfo/logo/marketmaker.png" class="mx-auto h-14">
            </div>
            <svg style="margin-top: -1px" class="mb-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920.07 64">
                <polygon class="b" points=".03 .5 960.03 63.5 1920.03 .5 .03 .5" />
            </svg>
            <div class="container mx-auto mt-4">
                <div class="mb-4">
                    <div class="px-4">
                        <!-- Header -->
                        <div class="items-center justify-between md:flex">
                            <div>
                                <h1 class="mb-1 text-xl font-medium">
                                    <i class="mr-2 fas fa-store"></i>{{$t('template.header.espace_apres_vente')}}
                                </h1>
                                <p class="mb-0 text-xs font-light text-gray-500">{{$t('template.header.gerer_vos_retours_produit_et_votre_service_apres_vente')}}</p>
                            </div>
                            <div class="mt-2 hide-on-desktop"></div>
                            <div class="flex items-center gap-4">
                                <div v-if="$companyTool.confFile().translates" class="flex items-center gap-2">
                                    <div @click="changeLangage(lang.lang)" v-for="(lang, langIndex) in langs" :key="'menu-lang-' + langIndex" style="text-decoration: none">
                                        <img class="h-[15px] cursor-pointer hover:opacity-50 duration-200" :src="lang.logo" />
                                    </div>
                                </div>
                                <div v-if="user" class="flex items-center">
                                    <dropdown-menu class="rounded-xl" :overlay="false" :transition="null" :direction="screenWidth >= 992 ? 'right' : 'left'">
                                        <button slot="trigger" id="dropdownUser" class="bg-gray-200 hover:bg-gray-300 focus:outline-none font-medium rounded-lg text-sm px-3 py-2.5" type="button">
                                            <i class="mr-1 fas fa-bars"></i> {{$t('template.header.menu')}}
                                        </button>
                                        <div slot="body" class="bg-white divide-y divide-gray-100">
                                            <ul class="px-0 py-0 my-0 text-sm text-gray-700" aria-labelledby="dropdownUser">
                                                <li class="px-3 py-2 font-bold border-b border-gray-200 bg-gray-50">
                                                    <i class="mr-1 fas fa-home"></i> {{$t('template.header.accueil')}}
                                                </li>
                                                <a :href="$router.resolve({ name: 'home'}).href" style="text-decoration: none">
                                                    <li class="px-3 py-2 text-gray-500 cursor-pointer hover:text-gray-700"> {{$t('template.header.accueil')}} </li>
                                                </a>
                                                <li class="px-3 py-2 font-bold border-gray-200 bg-gray-50 border-y">
                                                    <i class="mr-1 fas fa-folder"></i> {{$t('template.header.mes_produits')}}
                                                </li>
                                                <a :href="$router.resolve({name: 'user.product.list'}).href" style="text-decoration: none">
                                                    <li class="px-3 py-2 text-gray-500 cursor-pointer hover:text-gray-700"> {{$t('template.header.mes_produits')}} </li>
                                                </a>
                                                <li class="px-3 py-2 font-bold border-gray-200 bg-gray-50 border-y">
                                                    <i class="mr-1 fas fa-user"></i> {{user.prenom + ' ' + user.nom}}
                                                </li>
                                                <a :href="$router.resolve({ name: 'user.update'}).href" style="text-decoration: none">
                                                    <li class="px-3 py-2 text-gray-500 cursor-pointer hover:text-gray-700"> {{$t('template.header.parametres')}} </li>
                                                </a>
                                                <a :href="$router.resolve({ name: 'user.logout'}).href" style="text-decoration: none">
                                                    <li class="px-3 py-2 text-gray-500 cursor-pointer hover:text-gray-700"> {{$t('template.header.se_deconnecter')}} </li>
                                                </a>
                                            </ul>
                                        </div>
                                    </dropdown-menu>
                                    <router-link :to="{ name: 'form.home'}" style="text-decoration: none">
                                        <button type="button" class="ml-2 text-white bg-black hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-3 py-2.5">
                                            <i class="mr-2 fas fa-plus"></i>{{formAlreadyExists ? 'Continuer la demande' : 'Nouvelle demande'}}
                                        </button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <hr class="mt-3 mb-4">
                        <!-- Page content -->
                        <div class="grid grid-cols-6 gap-10">
                            <div class="hidden py-2 lg:block lg:col-span-2">
                                <div class="sticky top-2">
                                    <img class="top-0 rounded-xl" :src="getLeftImg" alt="">
                                </div>
                            </div>
                            <div class="col-span-12 pt-0 lg:col-span-4" :class="!getLeftImg ? 'lg:col-start-2' : ''">
                                <h1 v-if="getTitle" :class="getTitle.class" class="text-3xl font-bold" style="color: #B18857">
                                    <i v-show="getTitle.icon" :class="getTitle.icon"></i>
                                    <span :class="getTitle.labelClass">{{title}}</span>
                                </h1>
                                <div class="w-full">
                                    <slot></slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </sav-responsive-access-template>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

import SavResponsiveAccessTemplate from '../../../../components/SavResponsiveAccessTemplate.vue'

export default {
    props: {
        title: {
            type: String,
            default: "Marketmaker"
        },
        backButton: {
            type: Boolean,
            default: true
        },
        navigationBar: {
            type: Boolean,
            default: true
        }
    },
    components: {
        SavResponsiveAccessTemplate
    },
    data() {
        return {
            screenWidth: 0,
            user: null,
            langage: 'fr',
            langs: []
        }
    },
    computed: {
        getLeftImg() {
            let routesWithoutImages = [
                'user.login',
                'user.login.actors',
                'user.logout',
                'user.password-forgot',
                'user.password-token'
            ]
            if (routesWithoutImages.find((el) => el === this.$route.name)) {
                return null
            }

            let routesimages = [
                {name: 'home', url: require('./../../assets/tv1.jpg')},
                {name: 'user.product.list', url: require('./../../assets/tv3.jpg')},
                {name: 'user.update', url: require('./../../assets/tv4.jpg')},
            ]
            let getimage = routesimages.find((el) => el.name === this.$route.name)
            return getimage ? getimage.url : require('./../../assets/tv2.jpg')
        },
        displayInsideContainer() {
            let containerRoutes = [
                'form.home'
            ]
            return containerRoutes.find((el) => el === this.$route.name) ? true : false
        },
        getTitle() {
            let routeWithTitle = [
                {name: 'form.home', labelClass: 'ml-2'},
                {name: 'form.warranty-identification'},
                {name: 'user.product.list', class: 'mb-3', labelClass: 'ml-2', class: 'mb-3', icon: 'fas fa-tag'},
                {name: 'user.folder.list', labelClass: 'ml-2', class: 'mb-3', icon: 'fas fa-folder'},
            ]
            return routeWithTitle.find((el) => el.name === this.$route.name)
        },
        formAlreadyExists() {
            return localStorage['form-data'] ? true : false
        },
        cantDisplayOnMobile() {
            if (this.screenWidth <= 650 && !this.$companyTool.confFile().mobile) {
                return true
            }
            return false
        }
    },
    methods: {
        isSelect(routeName) {
            return (
                this.$route.name.split('.')[0] == routeName
                || this.$route.name == routeName
            ) ? true : false
        },
        changeLangage(lang) {
            localStorage.setItem('langage', lang)
            location.reload()
        },
        async getAllLang() {
            let response = await apiService.post('getalllang', {})
            this.langs = response.data.posts.post
        }
    },

    async mounted() {
        let userStorage = localStorage.getItem('user-session')
        userStorage = userStorage ? JSON.parse(userStorage) : null

        const d = new Date();
        let currentTime = d.getTime();

        if (userStorage && userStorage.user && (currentTime - userStorage.time) < 600000) {
            this.user = userStorage.user
        } else {
            this.user = await apiService.getUser()
            localStorage.setItem('user-session', JSON.stringify({
                user: await apiService.getUser(),
                time: currentTime
            }))
        }

        document.title = "Market Maker - Espace après-vente"
        document.body.style.backgroundColor = "#fff";
        document.body.style.color = "#000";

        this.screenWidth = window.innerWidth
        window.addEventListener('resize', (event) => {
            this.screenWidth = window.innerWidth
        }, true);

        // Colors
        var style = document.createElement("style")
        style.textContent = `
            .default-bg-color {background: #B18857 !important;}
            .default-text-color {color: #B18857 !important;}
            .default-bg-color-hover:hover {background: #000 !important;}
            .default-text-inside-color {color: #fff !important;}
        `
        document.head.appendChild(style)

        // Lang
        await this.getAllLang()
        const lang = await this.$companyTool.getLang()
        this.langage = lang
    },
}
</script>

<style>
.navigation {
    border-left: 5px solid white !important;
}
.navigation:hover {
    font-weight: 300 !important;
    color: black !important;
    background: rgb(248, 249, 250);
}

.navigation:hover .separator {
    background: black !important;
}
</style>



// WEBPACK FOOTER //
// src/companies/marketmaker/views/template/SavTemplate.vue